import type { ReactNode } from 'react'

import { Container } from './Container'
import { Footer } from './Footer'
import { Header } from './Header'
import { Main } from './Main'

type Props = {
	title: ReactNode
	children: ReactNode
	brandId: string | null
}

export const Page = ({ title, children, brandId }: Props) => (
	<Container>
		<Header brandId={brandId} title={title} />
		<Main>{children}</Main>
		<Footer />
	</Container>
)
